import {AfterViewInit, Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {finalize} from 'rxjs/operators';
import { GenericComponent } from 'src/app/core/util/abstract/generic-component';
import { DocumentsService } from 'src/app/core/service/api/documents.service';
import { showFeedback, showFeedbackError } from 'src/app/core/util/notification';
import { Globals } from 'src/app/globals';
import { Lightbox } from 'ngx-lightbox';
import { translate } from '@jsverse/transloco';

@Component({
  selector: 'app-download-sharepoint-version',
  templateUrl: './download-sharepoint-version.component.html',
  styleUrls: ['./download-sharepoint-version.component.css']
})
export class DownloadSharepointVersionComponent extends GenericComponent implements AfterViewInit {

  public versions = [];
  public initialized = false;
  public baseFilename: string;

  constructor(public dialogRef: MatDialogRef<DownloadSharepointVersionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private _documentsService: DocumentsService,
              private _lightbox: Lightbox,
              public globals: Globals, private snackBar: MatSnackBar) {
    super(globals);
    this.baseFilename = data.link;
  }

  ngAfterViewInit(): void {
    this._documentsService.getDocumentVersions(this.data.id).subscribe(
      (versions: any) => {
        this.versions = versions.reverse();
        this.initialized = true;
      },
      e => {
        if (e.status === 404) {
          if (!this.data.pivot.documentable_type || !this.data.pivot.documentable_id) {
            this.snackBar.open('Het bestand kan niet gevonden worden', 'Sluiten', {
              duration: 5000
            });

            return;
          }

          this.snackBar.open('Het bestand kan niet gevonden worden en wordt verwijderd', 'Sluiten', {
            duration: 5000
          });

          this._documentsService.removeDocument(this.data.pivot.documentable_type, this.data.pivot.documentable_id, this.data.id)
            .pipe(finalize(() => this.close({
                error: true
              }))
            )
            .subscribe();
        } else if (this.data.type === 'sharepoint' && this.openInSharepointFallback()) {
          showFeedback(translate('documents.sharepoint_open_fallback'));
          this.close();
        } else {
          showFeedbackError(e);
          this.close();
        }
      }
    );
  }

  private openInSharepointFallback(): boolean {
    const url = this._documentsService.getSharepointFileUrl(this.data.path);
    if (!url) {
      return false;
    }

    window.open(url, '_blank');
    return true;
  }

  public get isImage(): boolean {
    return !!(this.data?.mimetype?.includes('image') && this.data?.type?.includes('s3'));
  }

  public download(data?): void {
    this._documentsService.downloadSharPointDocument(this.data, data).subscribe({
      error: (e) => {
        if (this.data.type === 'sharepoint' && this.openInSharepointFallback()) {
          showFeedback(translate('documents.sharepoint_download_fallback'));
        } else {
          showFeedbackError(e);
        }
      }
    });
    this.dialogRef.close(data);
  }

  public close(data?): void {
    this.dialogRef.close(data);
  }
  public lightboxOpen(document){
    const albums = [];
    albums.push({
      src: document.path ? document.public_link : document.url,
      caption: document.path ? document.name : document.version,
      thumb: document.path ? document.path : document.version,
    });
    this._lightbox.open(albums);
  }
}
